/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
const INITIAL_CONTEXT = {
  idle: {},
  // GET_VERIFIED_CREDENTIAL: {
  //   offset: 0,
  //   size: 10,
  // },
};

const MACHINE_CONFIG = {
  id: "io.vlinder.tnt.verify-credential",
  initial: "idle",
  context: INITIAL_CONTEXT,
  states: {
    idle: {
      entry: ["resetAction"],
      on: {
        START: { target: "GET_VERIFIED_CREDENTIAL" },
      },
    },
    GET_VERIFIED_CREDENTIAL: {
      invoke: {
        id: "verifyCredential",
        src: "verifyCredential",
        onDone: {
          target: "RENDER_VERIFIED_CREDENTIAL_PAGE",
          actions: ["successAction"],
        },
        onError: {
          target: "RENDER_VERIFIED_CREDENTIAL_PAGE_ERROR",
          actions: ["failureAction"],
        },
      },
    },
    RENDER_VERIFIED_CREDENTIAL_PAGE: {
      on: {
        START: { target: "GET_VERIFIED_CREDENTIAL" },
      },
    },
    RENDER_VERIFIED_CREDENTIAL_PAGE_ERROR: {
      on: {
        START: { target: "GET_VERIFIED_CREDENTIAL" },
      },
    },
  },
};

//Machine(MACHINE_CONFIG)

export { INITIAL_CONTEXT, MACHINE_CONFIG };
